import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type AffectedStaffActionsType = {
  canViewCenterEnrollments: boolean
  canAccessDailyReport: boolean
  canAccessEndOfStayReport: boolean
}

export function getAffectedStaffActions(id: number): Promise<AffectedStaffActionsType> {
  return restApiClient
    .url(constructApiUrl(API.affectedStaffs.getActions.url, { id }))
    .get<AffectedStaffActionsType>()
}
